/**
 * What a customer sees while the back end is being updated (deploy-downtime plan §A5.3): requests wait it out by
 * themselves (api/retry.ts), so nothing they did is lost. After 4 minutes it offers "Try again", which sends every
 * waiting request at once. An approve waiting on another request's lease reads "Still adding to your cart…".
 */

import { useEffect, useState } from 'react';
import { onUpdateStatus, retryNow, updateStatus, type UpdateStatus } from '../api/retry.js';

export function UpdateBanner(): React.JSX.Element | null {
    const [status, setStatus] = useState<UpdateStatus>(updateStatus);
    useEffect(() => onUpdateStatus(setStatus), []);

    if (status.kind === 'idle') {
        return null;
    }
    return (
        <div className="update-banner" role="status" aria-live="polite" data-testid="update-banner">
            {status.kind === 'adding' ? (
                <>Still adding to your cart…</>
            ) : (
                <>
                    One moment, we’re updating. Your design is safe, and this page will carry on by itself.
                    {status.stalled && (
                        <>
                            {' '}This is taking longer than usual.{' '}
                            <button type="button" className="studio__inline" onClick={retryNow}>Try again</button>
                        </>
                    )}
                </>
            )}
        </div>
    );
}
